import React, { useState } from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import Chevron from 'assets/icons/chevron-right.svg';
import { Button } from 'components/button';
import { SmartLink } from 'components/smart-link';
import { LinkType, MenuItemType } from 'components/header/types';
import { classnames } from 'helpers/utils';
import * as styles from './collapsible-item.module.scss';

type CollapsibleItemProps = {
  menuItem: MenuItemType
};

export const CollapsibleItem = (props: CollapsibleItemProps) => {
  const { menuItem } = props;
  const [showMenuItem, onShowMenuItem] = useState(false);

  return (
    <div>
      <div className={styles.menuRowsContainer}>
        <div
          role="tab"
          tabIndex={showMenuItem ? 0 : -1}
          className={classnames(styles.rowTitle)}
        >
          {menuItem.link
            ? (
              <SmartLink className={styles.titleLink} to={menuItem.link}>
                {menuItem.name}
              </SmartLink>
            )
            : (
              <Button
                bStyle="ghost"
                alt={menuItem.name}
                className={classnames(styles.titleButton, styles.expandSectionButton, showMenuItem ? styles.expanded : '')}
                onClick={() => onShowMenuItem(!showMenuItem)}
              >
                <div>{menuItem.name}</div>
                <Chevron />
              </Button>
            )}
        </div>
        <div className={classnames(styles.sections, showMenuItem ? styles.visible : '')}>
          {showMenuItem && menuItem.sections.map((section) => {
            const image = getImage(section.callToAction?.image?.localFile);

            return (
              <div key={section.id} className={styles.sectionContent}>
                <div className={styles.sectionTitle}>
                  {section.title}
                  {section.viewAllLink && (
                  <SmartLink to={section.viewAllLink} className={styles.viewAllLink}>
                    View all
                    <Chevron />
                  </SmartLink>
                  )}
                </div>
                <div className={styles.linksContainer}>
                  {section.links.map((l: LinkType) => (
                    <SmartLink key={l.id} to={l.link} className={styles.link}>{l.name}</SmartLink>
                  ))}
                </div>
                {section.callToAction && (
                  <div className={styles.callToActionContent}>
                    {image && (
                      <GatsbyImage
                        image={image}
                        alt={section.title}
                        className={styles.callToActionImage}
                        objectFit="contain"
                      />
                    )}
                    {section.callToAction.button
                      && (
                      <SmartLink
                        className={styles.callToActionButton}
                        to={section.callToAction.button.link}
                      >
                        {section.callToAction?.button?.name}
                      </SmartLink>
                      )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
